import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { trigger, transition, style, animate } from '@angular/animations';
import { GameModeService } from '../../../_services/game-mode.service';
import { DismissalInterruptData } from '../../../interfaces/game-state.interface';
import { GlobalService } from 'src/app/_services/global.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-dismissal-interrupt',
  template: `
    <div class="interrupt-banner" *ngIf="interruptData" [@slideDown]>
      <div class="interrupt-content">
        <div class="interrupt-avatar">
          <img [src]="getStudentImage()" class="avatar-img" alt="" />
        </div>
        <div class="interrupt-text">
          <span class="interrupt-title">{{ currLang === 'ar' ? 'تم نداء طالب!' : 'Student Called!' }}</span>
          <span class="interrupt-student">{{ interruptData.studentName }}</span>
        </div>
        <button class="dismiss-btn" (click)="dismiss()">
          {{ currLang === 'ar' ? 'إغلاق اللعبة' : 'Close Game' }}
        </button>
      </div>
    </div>
  `,
  styles: [`
    .interrupt-banner {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      z-index: 3000;
      padding: 12px 24px;
      background: linear-gradient(135deg, #FF9800, #F57C00);
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
    }
    .interrupt-content {
      display: flex;
      align-items: center;
      gap: 16px;
      max-width: 800px;
      margin: 0 auto;
    }
    .interrupt-avatar {
      flex-shrink: 0;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      overflow: hidden;
      border: 2px solid rgba(255, 255, 255, 0.5);
    }
    .interrupt-avatar .avatar-img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .interrupt-text {
      flex: 1;
      display: flex;
      flex-direction: column;
    }
    .interrupt-title {
      color: white;
      font-size: 14px;
      font-weight: 700;
    }
    .interrupt-student {
      color: rgba(255, 255, 255, 0.8);
      font-size: 13px;
    }
    .dismiss-btn {
      padding: 8px 20px;
      border-radius: 20px;
      border: 2px solid white;
      background: transparent;
      color: white;
      font-size: 13px;
      font-weight: 600;
      cursor: pointer;
      white-space: nowrap;
      transition: background 0.2s;
    }
    .dismiss-btn:hover {
      background: rgba(255, 255, 255, 0.2);
    }
  `],
  animations: [
    trigger('slideDown', [
      transition(':enter', [
        style({ transform: 'translateY(-100%)' }),
        animate('0.3s ease-out', style({ transform: 'translateY(0)' }))
      ]),
      transition(':leave', [
        animate('0.2s ease-in', style({ transform: 'translateY(-100%)' }))
      ])
    ])
  ]
})
export class DismissalInterruptComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  interruptData: DismissalInterruptData | null = null;
  currLang: any = 'en';

  constructor(
    private gameModeService: GameModeService,
    private globalService: GlobalService
  ) {}

  ngOnInit(): void {
    this.globalService.getLang()
      .pipe(takeUntil(this.destroy$))
      .subscribe(lang => this.currLang = lang);

    this.gameModeService.dismissalInterrupt$
      .pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        this.interruptData = data;
        if (data) {
          this.dismiss();
        }
      });
  }

  getStudentImage(): string {
    const img = this.interruptData?.studentImage;
    if (img) {
      const filename = img.split('/').pop() || '';
      if (filename !== 'avatar.png') {
        return environment.img_url + img;
      }
    }
    return 'assets/images/avatar.png';
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  dismiss(): void {
    this.gameModeService.dismissDismissalInterrupt();
    this.gameModeService.closeGame();
  }
}
